import React, { useEffect, useState } from "react";
import CreatetableSelect from "react-select/creatable";
import { Col, Input, Label, Row } from "reactstrap";
import { getAddOnMaster } from "../../../../store/slices/clientsSlice";
import { useDispatch, useSelector } from "react-redux";

const MbForm = ({ value, onChange, handleInput, formFields }) => {
  const dispatch = useDispatch();
  const masterAddOns = useSelector((state) => state.clients.masterAddOns);

  const [typeOfBenefit, setTypeOfBendit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);
  const [benefitMode, setBenefitMode] = useState([
    { value: "complementary", label: "Complementary" },
    { value: "value", label: "Value" },
  ]);

  const [valueBenefitType, setValueBenefitType] = useState([
    { value: "percentage", label: "Percentage" },
    { value: "flat", label: "Flat" },
  ]);

  const validityOptions = [
    { value: "Month_1", label: "1 Month" },
    { value: "Months_3", label: "3 Months" },
    { value: "Months_6", label: "6 Months" },
    { value: "Months_9", label: "9 Months" },
    { value: "Year", label: "1 Year" },
    { value: "Year_2", label: "2 Years" },
  ];

  const programTypeOptions = [
    { value: "Cobranding", label: "Cobranding" },
    { value: "Whiteable_Solution", label: "Whiteable Solution" },
    { value: "Cyberior", label: "Cyberior" },
  ];

  const planTypeOptions = [
    { value: "try_30_days_free_trial", label: "try 30 days free trial" },
   
    { value: "General", label: "General" },
    { value: "TrialPlan", label: "Trial Plan" },
  ];

  const activationTriggerOptions = [
    { value: "on_account_activation", label: "On account activation" },
    { value: "on_upload", label: "On upload" },
    { value: "on_program_creation", label: "On program creation" },
  ];

  const addonOptions = [
    { value: "email", label: "Email" },
    { value: "card", label: "Card" },
    { value: "devices", label: "Devices" },
    { value: "bank_account", label: "Bank Account" },
    { value: "health_card", label: "Health Card" },
    { value: "mobile_number", label: "Mobile Number" },
    { value: "aadhar_number", label: "Aadhar Number" },
    { value: "driving_licence", label: "Driving Licence" },
    { value: "vehicle_insurance_card", label: "Vehicle InsuranceCard" },
    { value: "domain", label: "Domain" },
    { value: "social_media_handle", label: "SocialMediaHandle" },
    { value: "prepaid_card", label: "PrepaidCard" },
    { value: "loyaltyflyer_card", label: "LoyaltyFlyer Card" },
  ];

  const [formData, setFormData] = useState(value || {});

  useEffect(() => {
    if (value && JSON.stringify(value) !== JSON.stringify(formData)) {
      setFormData(value);
    }
  }, [value]);

  useEffect(() => {
    dispatch(getAddOnMaster({ isMaster: true }));
  }, [dispatch]);

  const handleInputParent = (event, index, field) => {
    const value = event?.value || event?.target?.value;

    let updatedForm = {
      ...formData,
      [field]: value,
    };

    if (field === "type" && value === "individual") {
      updatedForm = {
        type: "individual",
        // benefitMode: "",
        // valueBenefitType: "",
        // total_percentage: "",
        // total_quantity: "",
        // max_amount: "",
      };
    }

    if (field === "type" && value === "grouped") {
      updatedForm = {
        type: "grouped",
        // benefitMode: "",
        // valueBenefitType: "",
        // total_percentage: "",
        // total_quantity: "",
        // max_amount: "",
      };
    }

    if (field === "plan_type") {
      if (value !== "TrialPlan" && value !== "Refund") {
        if (updatedForm.days !== undefined) {
          const { days, ...rest } = updatedForm;
          updatedForm = { ...rest };
        }
      }
    }

    setFormData(updatedForm);

    if (typeof onChange === "function") {
      onChange(updatedForm);
    }

    console.log("Updated Form Data:", updatedForm);
  };

  const handleAddonChange = (key, field, value) => {
    const addons = { ...(formData.addons || {}) };
    if (!addons[key]) {
      addons[key] = { defaultFree: 1, maxSlot: "", purchaseSlot: "" };
    }
    addons[key][field] = value;

    const updatedForm = { ...formData, addons };
    setFormData(updatedForm);
    if (typeof onChange === "function") onChange(updatedForm);
  };

  return (
    <div>
      <Row className="g-3">
        <Col md="12">
          <div className="mt-2">
            <Label>Type of Benefit</Label>
            <CreatetableSelect
              options={typeOfBenefit}
              onChange={(event) => handleInput(event, "type")}
              value={typeOfBenefit.filter((x) => x.value === formFields?.type)}
            />
          </div>
        </Col>
      </Row>

      <Row className="g-3">
        <Col md="6">
          <div className="mt-2">
            <Label>Validity</Label>
            <Input
              type="select"
              value={formData.validity || ""}
              onChange={(event) => handleInputParent(event, 0, "validity")}
            >
              <option value="">Select validity</option>
              {validityOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </div>
        </Col>

        <Col md="6">
          <div className="mt-2">
            <Label>Program Type</Label>
            <Input
              type="select"
              value={formData.program_type || ""}
              onChange={(event) => handleInputParent(event, 0, "program_type")}
            >
              <option value="">Select program type</option>
              {programTypeOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </div>
        </Col>
      </Row>

      <Row className="g-3">
        <Col md="6">
          <div className="mt-2">
            <Label>Plan Type</Label>
            <Input
              type="select"
              value={formData.plan_type || ""}
              onChange={(event) => handleInputParent(event, 0, "plan_type")}
            >
              <option value="">Select plan type</option>
              {planTypeOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </div>
        </Col>

        <Col md="6">
          <div className="mt-2">
            <Label>Amount</Label>
            <Input
              type="number"
              placeholder="Enter amount"
              value={formData.amount || ""}
              onChange={(event) => handleInputParent(event, 0, "amount")}
            />
          </div>
        </Col>
      </Row>

      {(formData.plan_type === "TrialPlan" ||
        formData.plan_type === "Refund") && (
        <Row className="g-3 mt-2">
          <Col md="6">
            <div className="mt-2">
              <Label>Days</Label>
              <Input
                type="number"
                min="0"
                step="1"
                value={formData.days !== undefined ? formData.days : ""}
                onChange={(e) => {
                  const v = e.target.value;
                  const parsed = v === "" ? "" : parseInt(v, 10);
                  handleInputParent({ target: { value: parsed } }, 0, "days");
                }}
              />
            </div>
          </Col>
        </Row>
      )}

      <Row className="g-3">
        <Col md="6">
          <div className="mt-2">
            <Label>Plan Activation</Label>
            <Input
              type="select"
              value={formData.plan_activation || ""}
              onChange={(event) =>
                handleInputParent(event, 0, "plan_activation")
              }
            >
              <option value="">Select activation trigger</option>
              {activationTriggerOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </div>
        </Col>
    
      </Row>


      {/*  
      {formData?.type === "grouped" ? (
        <Row className="g-3">
          <Col md="6">
            <div className="mt-2">
              <Label>Select mode</Label>
              <CreatetableSelect
                options={benefitMode}
                onChange={(event) => handleInputParent(event, 0, "benefitMode")}
                value={benefitMode.filter(
                  (x) => x.value === formData.benefitMode
                )}
                isClearable
              />
            </div>
          </Col>
        </Row>
      ) : null}

      {formData?.benefitMode === "value" && formData?.type === "grouped" ? (
        <Row className="g-3">
          <Col md="6">
            <div className="mt-2">
              <Label>Select mode</Label>
              <CreatetableSelect
                options={valueBenefitType}
                onChange={(event) =>
                  handleInputParent(event, 0, "valueBenefitType")
                }
                value={valueBenefitType.filter(
                  (x) => x.value === formData.valueBenefitType
                )}
                isClearable
              />
            </div>
          </Col>

          <Col md="6">
            <div className="mt-2">
              <Label>Amount/Percentage</Label>
              <Input
                type="number"
                placeholder="Enter amount/percentage"
                value={formData.total_percentage || ""}
                max={formData.valueBenefitType === "percentage" ? 100 : null}
                onChange={(event) =>
                  handleInputParent(event, 0, "total_percentage")
                }
              ></Input>
            </div>
          </Col>
        </Row>
      ) : null}

      {formData?.type === "grouped" ? (
        <Row className="g-3">
          <Col md="6">
            <div className="mt-2">
              <Label>MB count</Label>
              <Input
                type="number"
                placeholder="Enter count"
                value={formData.total_quantity || ""}
                onChange={(event) =>
                  handleInputParent(event, 0, "total_quantity")
                }
              ></Input>
            </div>
          </Col>

          <Col md="6">
            <div className="mt-2">
              <Label>Max amount</Label>
              <Input
                type="text"
                placeholder="Enter max amount"
                value={formData.max_amount || ""}
                onChange={(event) => handleInputParent(event, 0, "max_amount")}
              ></Input>
            </div>
          </Col>
        </Row>
      ) : null}
      */}
    </div>
  );
};

export default MbForm;
